import { createSelector } from 'reselect';

export const getLoadingStatus = (state) => state.fcfiancaTable.requesting;
const getErrorStatus = state => state.fcfiancaTable.error;

const getSuccessStatus = createSelector(
  [getErrorStatus, getLoadingStatus],
  (error, isLoading) => !isLoading && !error && error !== undefined
);

export const getFCFiancaRequestsList = (state) => {
  if (getSuccessStatus(state)) {
    return state.fcfiancaTable.data;
  }
  return [];
}
